import { Grid, GridLayout } from '@zillow/constellation';
import { PostCard } from '@zillow/zrs-cms';
import React from 'react';

import type { Post } from '../../types/posts';
import PostsPagination from '../PostsPagination/PostsPagination';

export interface PostGridProps {
    posts: Post[];
    pages: number;
    page: number;
    archiveCategory?: string;
    baseLink: string;
    query?: Record<string, string>;
    incrementPaginationLinks?: boolean;
}

export default function PostGrid({
    posts,
    pages,
    page,
    archiveCategory,
    baseLink,
    query,
    incrementPaginationLinks,
}: PostGridProps) {
    return (
        <React.Fragment>
            <GridLayout layout="fluid12" gap="md">
                {posts.map((post, index) => (
                    <Grid
                        key={post.id}
                        gridColumnEnd={{ default: 'span 6', sm_lte: 'span 12' }}
                    >
                        <PostCard
                            url={{ href: post.link }}
                            alignment="vertical"
                            size="md"
                            category={getPrimaryCategory(post, archiveCategory)}
                            forceHideReadTime
                            forceShowCategory
                            loading={index === 0 ? 'eager' : 'lazy'}
                            title={post.title.raw}
                            image={post.featuredImage || undefined}
                        />
                    </Grid>
                ))}
            </GridLayout>
            <PostsPagination
                page={page}
                pages={pages}
                baseLink={baseLink}
                query={query}
                incrementPaginationLinks={incrementPaginationLinks}
            />
        </React.Fragment>
    );
}

function getPrimaryCategory(post: Post, archiveCategory?: string) {
    let badge: unknown;

    if (archiveCategory) {
        // If there is a subcategory for the archiveCategory, use first related subcategory.
        const relatedSubcategory = post.categories.find(
            (category: { parent: number | string }) =>
                String(category.parent) === archiveCategory
        );
        if (relatedSubcategory) {
            return relatedSubcategory;
        }
    }

    // If no badge yet the use primary category
    if (!badge && post.primaryCategory) {
        return post.primaryCategory;
    }

    // If no badge yet, then show first category in categories array if it has one
    if (!badge && post.categories.length) {
        return post.categories[0];
    }

    return null;
}
